import { render, staticRenderFns } from "./ColorModuleTable.vue?vue&type=template&id=fca1f88a&scoped=true"
import script from "./ColorModuleTable.vue?vue&type=script&lang=ts"
export * from "./ColorModuleTable.vue?vue&type=script&lang=ts"
import style0 from "./ColorModuleTable.vue?vue&type=style&index=0&id=fca1f88a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca1f88a",
  null
  
)

export default component.exports